module.exports = __webpack_public_path__ + "static/media/network-2402637_1280-small.6161192b.jpg";